import selectInsurance from 'utils/selectInsurance';

const getInsuranceInsuredsID = ({ patient, insurance, value, type }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  const selectedInsurance = insurance || selectInsurance(patient['Insurance Information']);
  const selectedInsuranceRelationToInsured = selectedInsurance
    ? selectedInsurance['Relation to Insured']
    : 'none';
  if (selectedInsurance['Claim Filling Code'].ID === 2 || selectedInsurance['Claim Filling Code'].ID === 3) {
    return patient['Social Security Number'] || '999999999';
  }
  if (type && type === 'Medicaid' && selectedInsurance['Claim Filling Code'].ID !== 4) {
    return null;
  }
  if (type && type === 'Medicare' && selectedInsurance['Claim Filling Code'].ID !== 5) {
    return null;
  }
  if (type && type === 'Private'
    && (selectedInsurance['Claim Filling Code'].ID === 5 || selectedInsurance['Claim Filling Code'].ID === 4)) {
    return null;
  }
  switch (selectedInsuranceRelationToInsured) {
    case 'Self':
      return selectedInsurance['Insurance ID'];
    case 'Spouse':
    case 'Child':
    case 'Other':
      return selectedInsurance['Related Insurance ID'];
    default:
      return null;
  }
};

export default getInsuranceInsuredsID;



// WEBPACK FOOTER //
// ./src/utils/print/getInsuranceInsuredsID.js